import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { take } from "rxjs/operators";

import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { SessionStorageService } from "ngx-store";
import { AlertService } from "ngx-alerts";

import { WsSpa } from "../services";
import { Page } from "../classes";
import { Usuario } from "../classes";
import { FormUsuarioComponent } from "../pages/gestao/usuarios/";
import { Message } from "@angular/compiler/src/i18n/i18n_ast";

@Component({
  selector: "app-suporte",
  templateUrl: "./full-layout.component.html",
})
export class FullLayoutComponent implements OnInit {
  public usuario = new Usuario();
  public loaders = { loading: false };
  public usuPage = new Page(
    "Alterar Dados",
    "Alterar",
    "alterar",
    "full-layout"
  );
  public data = new Date();
  public user;

  constructor(
    private storage: SessionStorageService,
    private router: Router,
    private wsSpa: WsSpa,
    private alert: AlertService,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef
  ) {}

  ngOnInit(): void {
    this.user = this.storage.get("usuario");
    this.loadUsuario();
  }

  public onLogout() {
    this.storage.clear();
    localStorage.clear();
    window.location.reload();
    setTimeout(() => {
      this.router.navigateByUrl("/login");
    }, 500);
  }

  public openModal(modal) {
    let initialState = { usuario: this.usuario, page: {} };
    switch (modal) {
      case "usuario":
        initialState = { usuario: this.usuario, page: this.usuPage };
        this.bsModalRef = this.modalService.show(FormUsuarioComponent, {
          initialState,
          class: "modal-lg",
        });
        break;
    }
    this.bsModalRef.content.action.pipe(take(1)).subscribe((e) => {
      this.loadUsuario();
    });
  }

  public loadUsuario() {
    this.loaders.loading = true;
    this.wsSpa
      .getFunction("search/usuario/codigo", this.user.id.toString(), "spaUrl")
      .subscribe(
        (data) => (data ? this.usuario.toClass(data[0]) : false),
        (error) => this.alert.danger(error.message)
      );
  }
}
